<ion-card class="carousel-card ion-no-margin ion-margin-bottom ion-text-start" [class.vertical]="vertical">
  <div class="image image--bg-mobile" [ngClass]="card.image?.length > 0 ? card.image : 'image--default'"></div>
  <div class="carousel-content">
    <ion-card-header>
      <ion-card-title class="ion-no-padding">
        <h5 class="ion-no-margin">{{ card.title }}</h5>
        <ion-badge *ngIf="card.cardType === 'poll' && card.activeInd" color="primary" class="body_3 bold">
          {{ counter * 1000 | date : 'HH:mm:ss' : 'UTC' }}
        </ion-badge>
      </ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-grid class="ion-no-padding">
        <ion-row class="description-row">
          <ion-col>
            <ion-text class="body_3" [innerHTML]="card.description"></ion-text>
          </ion-col>
        </ion-row>
        <ion-row class="survey-reward-container ion-margin-top ion-margin-bottom">
          <ng-container *ngIf="card.activeInd; else closed">
            <ion-col>
              <ion-text class="caption">Reward</ion-text>
              <ion-text>
                <fa-icon [icon]="card.cardType === 'poll' ? faTicket : faCoin" class="fa-coin"></fa-icon>
                <span class="body_3">{{ card.reward }}</span>
              </ion-text>
            </ion-col>
            <ion-col *ngIf="card.duration.length > 0">
              <ion-text class="caption">Length</ion-text>
              <ion-text class="body_3">{{ card.duration }} {{ card.duration.length === 1 ? 'Minute' : 'Minutes' }}</ion-text>
            </ion-col>
          </ng-container>
          <ng-template #closed>
            <ion-col>
              <ion-badge color="medium">
                <ion-text color="success">Already Answerd</ion-text>
              </ion-badge>
            </ion-col>
            <ion-col></ion-col>
          </ng-template>
          <ion-col *ngIf="vertical">
            <ion-buttons>
              <ion-button fill="clear" mode="md" [disabled]="disableButtonInd" (click)="continue.emit()">
                <fa-icon slot="icon-only" [icon]="faArrowRight" size="lg"></fa-icon>
              </ion-button>
            </ion-buttons>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="!vertical">
          <ion-col>
            <ion-button color="carouselbutton" expand="block" fill="solid" mode="ios" [disabled]="disableButtonInd" (click)="continue.emit()">
              {{ card.continueBtnText }}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </div>
</ion-card>
